import { IconFormNames } from 'shared/assets/icons';
import { ID } from 'shared/types/id';
import { Image } from 'shared/types/image';
import { LifeArea } from 'shared/types/life-area';

export enum LifeAreaColumnType {
  Name = 'name',
  Vision = 'vision',
  Goals = 'goals',
  Projects = 'projects',
}

export type LifeAreaRowData = {
  id: ID;
  name: string;
  image: Image | null;
  visionDescription: string | null;
  color: string | null;
  iconName: IconFormNames;
  goals: number;
  projects: number;
  lifeArea: LifeArea;
};
